module.exports = __webpack_public_path__ + "img/warning2-dent-red.69404def.svg";